
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import Bus from "@/lib/Bus";
import { Uploader } from "./Uploader";
const bus: Bus = new Bus().getBus();



@Component
export default class UploaderVue extends Vue {
  @Prop() type!: string;
  @Prop() usage!: string;
  @Prop() id!: string;
  @Prop() autorefresh!:boolean;
  @Prop() uploader_callback:Uploader|undefined;


  subdirectory!:string;
  filelist: any = [];
  names: any = [];

  key: number = 0;
  

  async beforeMount() { 
    this.subdirectory = this.type+'/'+this.usage+'/'+this.id
    await this.get_files_rep();
  }


  onChange(files: any) {

    let fls= (<any>this.$refs.file).files;

    const formData = new FormData();

    if (!fls || !fls.length) fls=files;
    for (let i = 0; i < fls.length; i++) this.filelist.push(fls[i]);
    
    formData.append("event", this.subdirectory);

    Array.from(Array(fls.length).keys()).map(x => {
      formData.append("files", fls[x], fls[x].name);
    });

    this.save(formData);
  }

  async save(formData: any) {
    formData.token=window.localStorage.getItem("token");
    const rawResponse = await fetch("/api/uploader/add_files", {
      method: "POST",
      body: formData,
    });
    const content = await rawResponse.json();
    this.get_files();
    return content;
  }

  is_image(n:string) {
    if (n.indexOf(".bmp")>-1) return true;
    if (n.indexOf(".img")>-1) return true;
    if (n.indexOf(".gif")>-1) return true;
    if (n.indexOf(".png")>-1) return true;
    return false;
  }

  @Watch('autorefresh')
  async onPropertyChanged(value: string, oldValue: string) {
    await this.get_files_rep()
    this.key++;
  }

  async get_files_rep() {
    if (this.autorefresh) {
      const that = this;
      that.get_files()
      await new Promise(resolve => setTimeout(() => resolve(that.get_files_rep()), 5000));
      
    } else {
      await this.get_files()
    }
  }

  async get_files() {
    this.names = await bus.call("/api/uploader/get_files", {subdirectory:this.subdirectory});
    let files:any={}
    for (let i=0;i<this.names.length;i++) {
      let name=this.names[i].name;
      files[name] = this.names[i]
    }
    bus.fire(this.subdirectory,{evt:"files_dropped", value:files})
    if (this.uploader_callback && this.names) {
      await this.uploader_callback.files_changed_cb(this.names);
    }
  }

  async remove(filename:string) {
    let p={subdirectory:this.subdirectory, filename:filename}
    await bus.call("/api/projekt/del_file", p);
    await this.get_files();
  }

  dragover(event: any) {
    event.preventDefault();
    // Add some visual fluff to show the user can drop its files
    if (!event.currentTarget.classList.contains("bg-green-300")) {
      event.currentTarget.classList.remove("bg-gray-100");
      event.currentTarget.classList.add("bg-green-300");
    }
  }
  dragleave(event: any) {
    // Clean up
    event.currentTarget.classList.add("bg-gray-100");
    event.currentTarget.classList.remove("bg-green-300");
  }
  drop(event: any) {
    event.preventDefault();
    let files: any = event.dataTransfer.files;
    this.onChange(files); // Trigger the onChange event manually
    // Clean up
    event.currentTarget.classList.add("bg-gray-100");
    event.currentTarget.classList.remove("bg-green-300");
  }

  show(url:string) {
   
    (<any>window).location.href = url
  }

}
